import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import FilterListIcon from "@material-ui/icons/FilterList";
import { IconButton } from "@material-ui/core";
import MuiTableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { HEAD_CELLS, HEAD_CELLS_NOT_INCLUDED, TAB_VALUE } from "../../constants";

const SITES_HEADERS = [
  "siteActivatedActual",
  "siteActivatedForecast",
  "siteClosedActual",
  "siteClosedForecast",
  "siteStatus",
];

const SITES_HEADERS_NOT_INCLUDED = [
  "siteActivatedActual",
  "siteActivatedForecast",
  "siteStatus",
];

// create a styled table cell with no horizontal padding
const StyledTableCell = withStyles((theme) => ({
  root: {
    padding: "5px",
    backgroundColor: "var(--surface-50)",

    "&:first-child": {
      paddingLeft: "10px",
    },
  },
}))(TableCell);
const TableSideHead = ({
  filterActive,
  setFilterActive,
  orderBy,
  order,
  onRequestSort,
  tabValue,
}) => {
  const classes = useStyles();
  const iconButtonClasses = useIconButtonStyles();

  const otherClasses = useOtherStyles();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const validHeaders = (tabValue === TAB_VALUE.SITES_NOT_INCLUDED) ?
    SITES_HEADERS_NOT_INCLUDED : SITES_HEADERS;
  const headers = (tabValue === TAB_VALUE.SITES_NOT_INCLUDED) ?
    HEAD_CELLS_NOT_INCLUDED : HEAD_CELLS;

  return (
    <MuiTableHead classes={classes}>
      <TableRow classes={classes}>
        <StyledTableCell>
          <IconButton
            disableRipple
            classes={iconButtonClasses}
            onClick={() => setFilterActive(!filterActive)}
          >
            <FilterListIcon
              fontSize="small"
              classes={iconButtonClasses}
            />
          </IconButton>
        </StyledTableCell>
        {headers.map(({ id, label }) => (
          <StyledTableCell
            style={
              ["country"].includes(id)
                ? { minWidth: "4rem" }
                : id === "central/local"
                ? { minWidth: "10rem" }
                : id === "siteNumber"
                ? { minWidth: "10rem" }
                : id === "siteSelectedDate"
                ? { minWidth: "6rem" }
                : validHeaders.includes(id)
                ? { width: "min-width: 13rem;" }
                : {}
            }
            key={id}
            align="left"
            padding="default"
            sortDirection={orderBy === id ? order : false}
          >
            <TableSortLabel
              active={orderBy === id}
              direction={orderBy === id ? order : "asc"}
              onClick={createSortHandler(id)}
            >
              <strong>{label}</strong>
              {orderBy === id ? (
                <span className={otherClasses.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableSideHead;

const useStyles = makeStyles((_) => ({
  root: {
    backgroundColor: "var(--surface-50)",
    borderRadius: "10px",
  },
}));

const useIconButtonStyles = makeStyles((_) => ({
  root: {
    color: "var(--text-primary)",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&.active": {
      backgroundColor: "var(--teal-300)",
    },
  },
}));

const useOtherStyles = makeStyles((_) => ({
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));
